import { render } from "./AlbumDetailsModal.vue?vue&type=template&id=ba1796c0&scoped=true"
import script from "./AlbumDetailsModal.vue?vue&type=script&lang=js"
export * from "./AlbumDetailsModal.vue?vue&type=script&lang=js"

import "./AlbumDetailsModal.vue?vue&type=style&index=0&id=ba1796c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba1796c0"]])

export default __exports__